import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { breakWord, capitalizeFirstLetter, formateDate, showStatus } from "../../../../utils/commonfunction";
import * as outfitServices from "../../services/outfitManagement.services";
import { useTranslation } from "react-i18next";

const OutfitView = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  console.log(showdefault,"xzzcccqww");
  
  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("heading_Outfits"), url: "/admin/outfitManagement/list/1" },
    { title: t("link_view"), url: "" },
  ];
 
  // const selected_language = localStorage.getItem("system_language")
  // console.log(selected_language)

  useEffect(() => {
    outfitServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  
  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("heading_view_outfit")}</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table  table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th>{t("list_heading_title")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.name ? showdefault.name : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_status")}</th>
                          <td>{showdefault && showdefault?.status === 0 ? toHtml(showStatus(showdefault.status)) : toHtml(showStatus(showdefault.status))}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_suitable")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.suitable ? showdefault.suitable : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_images")}</th>
                          <td>
                            {showdefault?.images && showdefault.images.length > 0 ? (
                              <div className="d-flex flex-wrap gap-2">
                                {showdefault.images.map((img, index) => (
                                  <img
                                    key={index}
                                    src={`${process.env.REACT_APP_SERVER_BASE_URL}/${img}`}
                                    alt="outfit"
                                    style={{
                                      objectFit: "cover",
                                      width: "30px",
                                      height: "30px",
                                      borderRadius: "6px",
                                      border: "1px solid #ddd",
                                    }}
                                  />
                                ))}
                              </div>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_category")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.category.title ? showdefault.category.title : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_notes")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.notes ? showdefault.notes : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_tag")}</th>
                          <td>
                            {showdefault?.tags?.length > 0
                              ? showdefault.tags.map((tag, index) => (
                                  <span key={index} className="text-capitalize">
                                    {tag}
                                    {index !== showdefault.tags.length - 1 && ", "}
                                  </span>
                                ))
                              : "-"}
                          </td>
                        </tr>
                        {/* <tr>
                          <th>{t("label_sub_category")}</th>
                          <td>
                            {showdefault?.subCategories?.length > 0
                              ? showdefault.subCategories.map((sub, index) => (
                                  <span key={sub._id}>
                                    {sub.title.split(" ")}
                                    {index < showdefault.subCategories.length - 1 ? ", " : ""}
                                  </span>
                                ))
                              : "-"}
                          </td>
                        </tr> */}

                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>{showdefault && showdefault.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_modified_date")}</th>
                          <td>{showdefault && showdefault?.updatedAt ? formateDate(showdefault.updatedAt) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_created_by")}</th>
                          <td>
                            {showdefault?.updatedBy ? (
                              <Link to={`/admin/customerManagement/customers/view/${showdefault.updatedBy._id}`}>
                                {showdefault.updatedBy.email}
                              </Link>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>

                      </tbody>
                    </table>
                    {/* <h6 className="main-content-label mb-3">{t("label_description")}:</h6> */}
                    {/* <div className="">{toHtml(showdefault && showdefault.description ? showdefault.description : "N/A")}</div> */}
                    {/* <div
                      className="text-capitalize"
                      dangerouslySetInnerHTML={{
                        __html: showdefault && showdefault?.description ? showdefault.description : "N/A",
                      }}></div> */}
                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OutfitView;
